import React, { useRef, useEffect, useContext } from "react";
import PerfectScrollbar from "perfect-scrollbar";
import { Route, Switch, Redirect } from "react-router-dom";

import { UserContext } from "context/auth";

import AuthNavbar from "components/Navbars/AuthNavbar.js";
import Footer from "components/Footer/Footer.js";

import routes from "routes.js";

var ps;

function Auth(props) {
  
  let { user } = useContext(UserContext)
  let { loggedIn } = user

  let fullPages = useRef()

  useEffect(() => {

    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(fullPages);
    }

    return () => {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
    }
  }, [])

  let getRoutes = (routes) => {

    return routes.map((prop, key) => {

      if (prop.collapse) {
        return getRoutes(prop.views);
      }

      if (prop.layout === "/auth") {

        if (loggedIn)
          return <Redirect key={key} to='/admin/home' />

        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    })
  }

  return (
    <>
      <div className="wrapper wrapper-full-page" ref={(ref) => { fullPages = ref }}>
        <div className="full-page section-image">
          <Switch>{getRoutes(routes)}</Switch>
        </div>
      </div>
    </>
  )

}


export default Auth;
